import { FaEye } from 'react-icons/fa';
import { useAuditLogContext } from '../../contexts/AuditLogProvider';
import { AuditLog } from '../../types/auditLogs';

const ShowLogDetailsBtn = ({ auditLog }: { auditLog: AuditLog }) => {
  // integration of context hooks here
  const { setShowLogDetails, setAuditLog } = useAuditLogContext();

  // rendering show log details button component here
  return (
    <div className='flex items-center justify-center'>
      <button
        type='button'
        onClick={() => {
          setShowLogDetails(true);
          setAuditLog(auditLog);
        }}
        className='flex items-center justify-center gap-2 bg-base-light-blue rounded-md px-3 py-1 text-sm text-base-white hover:opacity-70 active:scale-95 duration-300'
      >
        <FaEye />
        <span>View Details</span>
      </button>
    </div>
  );
};

export default ShowLogDetailsBtn;
